module.exports = __webpack_public_path__ + "img/kt1_1.2136e24c.png";